// Remote — state of a value loaded from elsewhere. Tagged shape with
// prefixed tags. Replaces a nullable value + parallel error pair.
//
// Consumer API: `Remote.notAsked`, `Remote.loading`,
// `Remote.reloading(prev)`, `Remote.loaded(x)`, `Remote.failed(e)`,
// `Remote.isLoaded(r)`, `Remote.map(f)(r)`, `Remote.startLoad(r)`,
// `Remote.match({notAsked, loading, reloading, loaded, failed})(r)`.
//
// `Reloading` is stale-while-revalidate: a read in flight that still
// carries the last good value. Emptiness is a property of the value
// (`Loaded([])`), never a case.
export { failed, isLoaded, loaded, loading, map, match, notAsked, reloading, startLoad, };
const notAsked = { _tag: "Remote.NotAsked" };
const loading = { _tag: "Remote.Loading" };
const reloading = (prev) => ({
    _tag: "Remote.Reloading",
    prev,
});
const loaded = (value) => ({ _tag: "Remote.Loaded", value });
const failed = (error) => ({ _tag: "Remote.Failed", error });
const isLoaded = (r) => r._tag === "Remote.Loaded";
const match = (cases) => (r) => {
    switch (r._tag) {
        case "Remote.NotAsked":
            return cases.notAsked();
        case "Remote.Loading":
            return cases.loading();
        case "Remote.Reloading":
            return cases.reloading(r.prev);
        case "Remote.Loaded":
            return cases.loaded(r.value);
        case "Remote.Failed":
            return cases.failed(r.error);
    }
};
// Maps the value held by Loaded and Reloading; other states pass through.
const map = (f) => (r) => match({
    notAsked: () => notAsked,
    loading: () => loading,
    reloading: (prev) => reloading(f(prev)),
    loaded: (value) => loaded(f(value)),
    failed: failed,
})(r);
// A read begins: keep the last good value if there is one (Loaded or
// Reloading -> Reloading), otherwise a cold Loading.
const startLoad = (r) => match({
    notAsked: () => loading,
    loading: () => loading,
    reloading: reloading,
    loaded: reloading,
    failed: () => loading,
})(r);
//# sourceMappingURL=remote.js.map